import React from 'react'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'

const Head = ({ intl, title }) => (
  <Helmet
    titleTemplate={`%s | ${intl.formatMessage({
      id: 'Common.app.name'
    })}`}
    defaultTitle={intl.formatMessage({ id: 'Common.app.name' })}
    title={title}
  />
)

export default injectIntl(Head)



// WEBPACK FOOTER //
// ./src/components/Head/index.js